import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { danhSachDangKyNganh2Api } from "../../../api/quan-ly-nganh-2/danhSachDangKyNganh2Api";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { eDanhSachDangKyNganh2ActionIds, IDanhSachDangKyNganh2ActionTypes } from "../../action-types/quan-ly-nganh-2/IDanhSachDangKyNganh2Actions";
import { rootActions } from "../../actions/rootActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { IDanhSachDangKyNganh2UpdateDuyetRequest } from "../../../model/request/quan-ly-nganh-2/IDanhSachDangKyNganh2UpdateDuyetRequest";

export function* danhSachDangKyNganh2Saga(): any {
    yield takeLatest(eDanhSachDangKyNganh2ActionIds.LOAD_BY_DOT_START, loadByDotXetWorker);
    yield takeEvery(eDanhSachDangKyNganh2ActionIds.DUYETS_START, updateDuyetWorker);
}

function* loadByDotXetWorker(action: IDanhSachDangKyNganh2ActionTypes): any {
    const id_dot_dang_ky = action.payload as number;
    const res: IBaseResponse = yield call(danhSachDangKyNganh2Api.SelectByDotDangKy, id_dot_dang_ky );
    if (res.is_success) {
        yield put(rootActions.quanLyNganh2.danhSachDangKyNganh2.LOAD_BY_DOT_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(rootActions.quanLyNganh2.danhSachDangKyNganh2.LOAD_BY_DOT_ERROR(res.message ?? "Có lỗi khi tải danh sách đăng ký ngành 2"));
    }
}

function* updateDuyetWorker(action: IDanhSachDangKyNganh2ActionTypes): any {
    const request = action.payload as IDanhSachDangKyNganh2UpdateDuyetRequest;
    const res: IBaseResponse = yield call(danhSachDangKyNganh2Api.Duyets, request);
    if (res.is_success) {
        yield put(rootActions.quanLyNganh2.danhSachDangKyNganh2.DUYETS_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(rootActions.quanLyNganh2.danhSachDangKyNganh2.DUYETS_ERROR(res.message ?? "Có lỗi khi duyệt danh sách đăng ký ngành 2"));
    }
}